import ImageFramingEditor from "../../../../shared/ui/media/ImageFramingEditor.jsx";
import { editSlider, createSlider, deleteSlider } from "../../api/slider/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Switch } from "@mui/material";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal, NumberInput, TextInput, UploadImage } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";



const EditSliderModal = ({
  open,
  close,
  data,
  forEdit,
  setAllRows,
  allRows,
}) => {
  const { token } = useSelector((state) => state.user);
  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);

  const [loading, setLoading] = useState(false);

  // form fields
  const [files, setFiles] = useState([]);
  const [link, setLink] = useState("");
  const [priority, setPriority] = useState(1);
  const [framing, setFraming] = useState({ imageFit: "cover", positionX: 50, positionY: 50 });
  const [mobileView, setMobileView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  useEffect(() => {
    if (data && forEdit) {
      setLink(data.link);
      setFiles([]); setselectedProductImage();
      setFraming({ imageFit: data.imageFit ?? "cover", positionX: data.positionX ?? 50, positionY: data.positionY ?? 50 });
      setMobileView(data.mobileView);
      setPriority(data.priority);
    } else {
      resetData();
    }
  }, [data, forEdit]);

  const resetData = () => {
    setFiles([]);
    setLink("");
    setPriority(1);
    setMobileView(false);
    setFraming({ imageFit: "cover", positionX: 50, positionY: 50 });
    setselectedProductImage();
  };

  const submitData = () => {
    /*    var fd = {
      link,
      priority,
      files,
      mobileView,
      fromGallery: selectedProductImage ? selectedProductImage : "",
    }; */
    const fd = new FormData();
    fd.append("link", link);
    fd.append("priority", priority);
    if (files instanceof File) fd.append("files", files);
    fd.append("mobileView", mobileView);
    Object.entries(framing).forEach(([key, value]) => fd.append(key, String(value)));
    if (selectedProductImage) fd.append("fromGallery", selectedProductImage);
    var temp = [...allRows];
    setLoading(true);
    if (forEdit) {
      fd.append("id", data.id);
      /*   fd = { ...fd, id: data.id }; */
      editSlider(fd, token)
        .then((res) => {
          var index = temp.findIndex((item) => item.id === data.id);
          temp[index] = res.data.data;
          setAllRows(temp);
          setLoading(false);
          close();
          resetData();
          toast.success("با موفقیت ویرایش شد");
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);

          setLoading(false);
        });
    } else {
      createSlider(fd, token)
        .then((res) => {
          temp.unshift(res.data.data);

          setAllRows(temp);
          setLoading(false);
          toast.success("با موفقیت اضافه شد");
          close();
          resetData();
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);

          setLoading(false);
        });
    }
  };

  const deleteItem = () => {
    if (data) {
      setLoading(true);
      deleteSlider(data, token)
        .then((res) => {
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          setLoading(false);
          setOpenDelete(false);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
        });
    }
  };

  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  اسلایدر`}
    >
      <div className="leftInput">
        {" "}
        <TextInput label="لینک تصویر" change={setLink} currentValue={link} />
      </div>

      <NumberInput label="اولویت نمایش" change={setPriority} value={priority} />
      <UploadImage
        previewSize="original"
        file={files}
        change={setFiles}
        address={data?.galleryId}
        selectedProductImage={selectedProductImage}
        setselectedProductImage={setselectedProductImage}
      />
      <Box>
        <span style={{ fontFamily: "IRANSansFa" }}>برای نمایش در موبایل:</span>
        <Switch
          checked={Boolean(mobileView)}
          onChange={() => setMobileView(!mobileView)}
        />
      </Box>
      <ImageFramingEditor file={files} galleryId={selectedProductImage || data?.galleryId} mobile={mobileView}
        value={framing} onChange={setFraming} disabled={loading} />
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={submitData}
          disabled={loading}
          sx={{ width: { xs: "50%", md: "auto" } }}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این اسلایدر اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteItem}
        open={openDelete}
      />
    </Modal>
  );
};

export default EditSliderModal;
